export default {
  name: 'ColorDipslay',
  props: {
    data: {
      type: String
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
